/* Ardor Yard Sign Builder: the AI design drawer ("AI design" on the tool rail). Ardor Printing. New Oct 11, 2026 (AI-YARD).
Made from the flag designer's drawer (assets/ardor-flag-ai.js) for the yard sign builder. Builds its form inside the drawer
panel that assets/ardor-yardsign-ai-layers.js adds ([data-aya-host]). Uses the AI server the AI banner generator uses
(ws-idea-api, product "banner", no server change): POST /api/banner/logo, /api/banner/generate, /api/banner/final,
GET /api/banner/quota, with the same visitor id / email (localStorage wsIdeaVisitor / wsIdeaEmail) and the same invisible
Cloudflare Turnstile check, so tries are shared with the AI generator pages.
The request uses the sign's current size in feet (24 x 18 in = 2 x 1.5 ft). The picked design is made print-ready (/final)
and handed to ArdorYardSignLayers.placeAi(), which puts it on the face being edited (the back only with 2 sides and
"Different back"; otherwise the front) in Fill mode, like any uploaded picture. */
(function () {
  'use strict';
  var root = document.querySelector('[data-abb-root]');
  if (!root || root.__aya) return;
  root.__aya = true;

  var CONF = {};
  try { CONF = JSON.parse(root.querySelector('[data-abb-config]').textContent); } catch (e) { CONF = {}; }
  var API_BASE = String(CONF.ideaApi || 'https://ws-idea-api.dayne-18a.workers.dev').replace(/\/+$/, '');
  var SITEKEY = String(CONF.turnstile || '');
  var AI_PAGE = String(CONF.ideasUrl || ''); // the full AI generator page; empty = no link (there is no yard sign AI page)
  var LIMITS = { headline: 60, subline: 80, details: 120, notes: 300 };
  var STYLES = [['bold', 'Bold'], ['clean', 'Clean'], ['fun', 'Fun'], ['elegant', 'Elegant'], ['vintage', 'Vintage'], ['event', 'Event']];
  var MAX_LOGO_PX = 1536, MAX_LOGO_BYTES = 8 * 1024 * 1024;

  function store(k, v) { try { if (v === undefined) return window.localStorage.getItem(k); window.localStorage.setItem(k, v); } catch (e) {} return null; }
  var visitor = store('wsIdeaVisitor');
  if (!visitor || !/^[a-zA-Z0-9_-]{8,64}$/.test(visitor)) {
    visitor = ((window.crypto && crypto.randomUUID) ? crypto.randomUUID() : String(Date.now()) + Math.random().toString(36).slice(2)).replace(/[^a-zA-Z0-9_-]/g, '');
    store('wsIdeaVisitor', visitor);
  }
  var email = store('wsIdeaEmail') || '';
  var S = { style: 'bold', logo: null, logoId: '', busy: false, left: null, hasEmail: false, emailTries: 10, batch: null, timer: 0 };
  var ui = {};

  function el(tag, cls, html) { var n = document.createElement(tag); if (cls) n.className = cls; if (html != null) n.innerHTML = html; return n; }
  function $(s, r) { return (r || ui.host || document).querySelector(s); }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function clean(t) { return String(t || '').replace(/\s+/g, ' ').trim(); }
  function validEmail(e) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(e); }
  function track(name, data) { try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data || {})); } catch (e) {} }
  function YS() { return window.ArdorYardSignAPI; }
  function LY() { return window.ArdorYardSignLayers; }
  function nice(n) { var r = Math.round(n * 100) / 100; return String(r); }

  // ---------- the sign being designed: what to ask the AI for, and which face the design goes on ----------
  function plan() {
    var A = YS(), c = A.cfg(), st = A.state || {};
    var two = c.sides === 2, diff = two && st.backMode === 'different';
    var face = diff && A.editFace() === 'back' ? 'back' : 'front';
    var ft = function (n) { return Math.max(0.5, Math.min(200, Math.round(n / 12 * 100) / 100)); };
    return { c: c, face: face, two: two, diff: diff, widthFt: ft(c.Wi), heightFt: ft(c.Hi), size: nice(c.Wi) + ' x ' + nice(c.Hi) + ' in' };
  }

  // ---------- server ----------
  function api(path, body, ms) {
    var opts = {};
    if (body instanceof FormData) { opts.method = 'POST'; opts.body = body; }
    else if (body) { opts.method = 'POST'; opts.headers = { 'Content-Type': 'application/json' }; opts.body = JSON.stringify(body); }
    var ctl = window.AbortController ? new AbortController() : null, t = 0;
    if (ctl) { opts.signal = ctl.signal; t = setTimeout(function () { ctl.abort(); }, ms || 180000); }
    return fetch(API_BASE + path, opts).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        clearTimeout(t);
        if (!j || typeof j !== 'object') j = {};
        if (r.status === 402 && !j.error) j.error = 'need_email';
        if (!r.ok) { if (!j.error) j = { ok: false, error: 'server', message: 'Something went wrong on our side. Please try again.' }; j.ok = false; }
        return j;
      });
    }, function (e) {
      clearTimeout(t);
      return e && e.name === 'AbortError' ? { ok: false, error: 'timeout', message: 'This is taking longer than usual. Please try again.' } : { ok: false, error: 'network', message: 'Check your connection and try again.' };
    });
  }
  function withEmail(b) { if (S.hasEmail && email) b.email = email; return b; }
  function quota() {
    var q = 'visitor=' + encodeURIComponent(visitor) + (email ? '&email=' + encodeURIComponent(email) : '');
    return fetch(API_BASE + '/api/banner/quota?' + q).then(function (r) { return r.json(); }).then(function (j) {
      if (j && j.ok) { S.left = j.bannersLeft; S.hasEmail = !!j.hasEmail; S.emailTries = j.emailBanners || S.emailTries; if (j.enabled === false) S.off = true; }
      syncQuota();
    }).catch(function () {});
  }

  // ---------- Turnstile: explicit render, invisible, a fresh token for every request ----------
  var tsReady = null, tsWidget = null, tsResolve = null;
  function loadTurnstile() {
    if (!SITEKEY) return Promise.resolve(false);
    if (tsReady) return tsReady;
    tsReady = new Promise(function (res) {
      if (window.turnstile && window.turnstile.render) { res(true); return; }
      window.ayaTurnstileLoaded = function () { res(true); };
      var s = document.createElement('script');
      s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=ayaTurnstileLoaded';
      s.async = true; s.defer = true;
      s.onerror = function () { res(false); };
      document.head.appendChild(s);
    });
    return tsReady;
  }
  function botToken() {
    return loadTurnstile().then(function (ok) {
      if (!ok || !window.turnstile) return '';
      return new Promise(function (res) {
        tsResolve = res;
        var take = function (t) { var r = tsResolve; if (r) { tsResolve = null; r(t || ''); } };
        try {
          if (tsWidget === null) tsWidget = window.turnstile.render($('[data-aya-ts]'), { sitekey: SITEKEY, execution: 'execute', appearance: 'interaction-only', callback: take, 'error-callback': function () { take(''); } });
          else window.turnstile.reset(tsWidget);
          window.turnstile.execute(tsWidget);
        } catch (e) { take(''); }
        setTimeout(function () { if (tsResolve === res) take(''); }, 45000);
      });
    });
  }

  // ---------- logo: any picture, made a PNG up to 1536 px for the AI ----------
  function toPng(file) {
    return new Promise(function (res, rej) {
      var u = URL.createObjectURL(file), im = new Image();
      im.onload = function () {
        var w = im.naturalWidth || 800, h = im.naturalHeight || 800, k = Math.min(1, MAX_LOGO_PX / Math.max(w, h));
        var cv = document.createElement('canvas'); cv.width = Math.max(1, Math.round(w * k)); cv.height = Math.max(1, Math.round(h * k));
        cv.getContext('2d').drawImage(im, 0, 0, cv.width, cv.height);
        URL.revokeObjectURL(u);
        cv.toBlob(function (b) { if (b) res(b); else rej(new Error('png')); }, 'image/png');
      };
      im.onerror = function () { URL.revokeObjectURL(u); rej(new Error('decode')); };
      im.src = u;
    });
  }
  function uploadLogo() {
    if (!S.logo) return Promise.resolve('');
    if (S.logoId) return Promise.resolve(S.logoId);
    return toPng(S.logo).then(function (b) {
      if (b.size > MAX_LOGO_BYTES) throw { message: 'Your logo is too big. Try a smaller file.' };
      var fd = new FormData(); fd.append('file', b, 'logo.png'); fd.append('visitor', visitor);
      return api('/api/banner/logo', fd, 60000);
    }, function () { throw { message: 'We couldn\'t read that logo. Upload a PNG, JPG or SVG file.' }; }).then(function (j) {
      if (!j.ok || !j.logoId) throw j;
      S.logoId = j.logoId; return j.logoId;
    });
  }

  // ---------- UI ----------
  function build(host) {
    ui.host = host;
    host.innerHTML =
      '<div class="aya">' +
      '<p class="abl-help aya-lead">Type your words and pick a style. Our AI draws 4 designs for your <b data-aya-size></b> sign. Tap one to put it on your sign, then move or resize it.</p>' +
      '<p class="aya-face" data-aya-face hidden></p>' +
      '<label class="aya-field"><span>Main words <em>(required)</em></span><input class="abl-input aya-in" data-aya-line="headline" maxlength="' + LIMITS.headline + '" placeholder="For example: OPEN HOUSE" autocomplete="off"></label>' +
      '<label class="aya-field"><span>Second line <em>(optional)</em></span><input class="abl-input aya-in" data-aya-line="subline" maxlength="' + LIMITS.subline + '" placeholder="For example: Saturday 10 to 2" autocomplete="off"></label>' +
      '<label class="aya-field"><span>Details <em>(optional)</em></span><input class="abl-input aya-in" data-aya-line="details" maxlength="' + LIMITS.details + '" placeholder="Phone, website or address" autocomplete="off"></label>' +
      '<div class="aya-field"><span>Style</span><div class="aya-styles" data-aya-styles></div></div>' +
      '<label class="aya-field"><span>Colors, pictures or mood <em>(optional)</em></span><textarea class="abl-input aya-in aya-notes" rows="2" data-aya-notes maxlength="' + LIMITS.notes + '" placeholder="For example: navy and gold, a house"></textarea></label>' +
      '<div class="aya-field"><span>Your logo <em>(optional)</em></span><div class="aya-logo"><input type="file" accept="image/png,image/jpeg,image/webp,image/svg+xml" data-aya-logo-in hidden><button type="button" class="aya-btn aya-btn--ghost" data-aya-logo-btn>Add your logo</button><span class="aya-logo__name" data-aya-logo-name></span><button type="button" class="aya-x" data-aya-logo-x hidden aria-label="Remove the logo">&times;</button></div></div>' +
      '<div class="aya-gate" data-aya-gate hidden><p class="abl-help">You\'ve used today\'s free tries. Add your email for <span data-aya-gate-n>10</span> tries a day.</p><div class="aya-gate__row"><input class="abl-input aya-in" type="email" data-aya-email placeholder="you@example.com" autocomplete="email" aria-label="Your email"><button type="button" class="aya-btn" data-aya-email-go>Continue</button></div></div>' +
      '<p class="aya-err" data-aya-err role="alert" hidden></p>' +
      '<button type="button" class="aya-btn aya-btn--go" data-aya-go>Design my sign</button>' +
      '<p class="aya-quota" data-aya-quota></p>' +
      '<div class="aya-status" data-aya-status aria-live="polite" hidden></div>' +
      '<div class="aya-results" data-aya-results></div>' +
      '<div class="aya-ts" data-aya-ts></div>' +
      (AI_PAGE ? '<p class="abl-help aya-more">Want more room to try ideas? <a data-aya-page href="' + esc(AI_PAGE) + '">Open the full AI generator</a>.</p>' : '') +
      '</div>';
    var st = $('[data-aya-styles]');
    STYLES.forEach(function (s) {
      var b = el('button', 'aya-chip', esc(s[1])); b.type = 'button'; b.setAttribute('data-aya-s', s[0]); b.setAttribute('aria-pressed', s[0] === S.style ? 'true' : 'false');
      st.appendChild(b);
    });
    host.addEventListener('click', onClick);
    $('[data-aya-logo-in]').addEventListener('change', function (e) {
      var f = e.target.files && e.target.files[0]; e.target.value = '';
      if (!f) return;
      if (f.size > 30 * 1024 * 1024) { showErr('That logo file is too big. Try one under 30 MB.'); return; }
      S.logo = f; S.logoId = ''; syncLogo();
    });
    host.addEventListener('input', function () { showErr(''); });
    syncSign(); syncLogo(); quota();
    // keep the size and face line current (size, sides and face are all picked with clicks)
    root.addEventListener('click', function () { setTimeout(syncSign, 0); });
    root.addEventListener('change', function () { setTimeout(syncSign, 0); });
  }
  function onClick(e) {
    var b = e.target.closest('button, a'); if (!b) return;
    if (b.hasAttribute('data-aya-s')) { S.style = b.getAttribute('data-aya-s'); [].forEach.call(ui.host.querySelectorAll('[data-aya-s]'), function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); }); return; }
    if (b.hasAttribute('data-aya-logo-btn')) { $('[data-aya-logo-in]').click(); return; }
    if (b.hasAttribute('data-aya-logo-x')) { S.logo = null; S.logoId = ''; syncLogo(); return; }
    if (b.hasAttribute('data-aya-go')) { generate(); return; }
    if (b.hasAttribute('data-aya-email-go')) { useEmail(); return; }
    if (b.hasAttribute('data-aya-use')) { useDesign(b.getAttribute('data-aya-use')); return; }
    if (b.hasAttribute('data-aya-page')) { var p = plan(); b.href = AI_PAGE + (AI_PAGE.indexOf('?') < 0 ? '?' : '&') + 'size=' + nice(p.c.Wi) + 'x' + nice(p.c.Hi); }
  }
  function syncSign() {
    if (!ui.host || !YS()) return;
    var p = plan();
    var s = $('[data-aya-size]'); if (s) s.textContent = p.size;
    var f = $('[data-aya-face]');
    if (f) {
      f.hidden = !p.two;
      f.textContent = !p.two ? '' : (!p.diff ? 'Same on both sides: the design goes on the front and prints on both sides.' : (p.face === 'back' ? 'The design goes on the back of your sign.' : 'The design goes on the front of your sign. To design the back, switch to the back first.'));
    }
  }
  function syncLogo() {
    $('[data-aya-logo-name]').textContent = S.logo ? S.logo.name : '';
    $('[data-aya-logo-x]').hidden = !S.logo;
    $('[data-aya-logo-btn]').textContent = S.logo ? 'Change logo' : 'Add your logo';
  }
  function syncQuota() {
    var q = $('[data-aya-quota]'); if (!q) return;
    if (S.off) { q.textContent = 'AI design is resting right now. Please try again later.'; $('[data-aya-go]').disabled = true; return; }
    if (S.left == null) { q.textContent = ''; return; }
    q.textContent = S.left > 0 ? (S.left + (S.left === 1 ? ' try' : ' tries') + ' left today' + (S.hasEmail ? '' : ' · 4 designs each · no sign-up')) : (S.hasEmail ? 'No tries left today' : 'Add your email for more tries');
    var n = $('[data-aya-gate-n]'); if (n) n.textContent = String(S.emailTries);
  }
  function showErr(m) { var e = $('[data-aya-err]'); if (!e) return; e.textContent = m || ''; e.hidden = !m; }
  function busy(on, text) {
    S.busy = on;
    [].forEach.call(ui.host.querySelectorAll('button, input, textarea'), function (x) { x.disabled = on; });
    var s = $('[data-aya-status]'); clearInterval(S.timer);
    if (!on) { s.hidden = true; s.textContent = ''; $('[data-aya-go]').textContent = 'Design my sign'; if (S.off) $('[data-aya-go]').disabled = true; return; }
    var t0 = Date.now();
    s.hidden = false;
    var tick = function () { s.textContent = text + ' ' + Math.round((Date.now() - t0) / 1000) + ' s'; };
    tick(); S.timer = setInterval(tick, 1000);
    $('[data-aya-go]').textContent = 'Designing…';
  }
  function readLines() {
    var L = {};
    [].forEach.call(ui.host.querySelectorAll('[data-aya-line]'), function (x) { var k = x.getAttribute('data-aya-line'), v = clean(x.value).slice(0, LIMITS[k]); if (v) L[k] = v; });
    return L;
  }
  function openGate(retry) {
    S.retry = retry;
    $('[data-aya-gate]').hidden = false;
    var e = $('[data-aya-email]'); if (e) { e.value = email || ''; try { e.focus(); } catch (er) {} }
  }
  function useEmail() {
    var v = clean($('[data-aya-email]').value).toLowerCase();
    if (!validEmail(v)) { showErr('Please type a valid email.'); return; }
    email = v; store('wsIdeaEmail', v); S.hasEmail = true;
    $('[data-aya-gate]').hidden = true;
    quota().then(function () { var r = S.retry; S.retry = null; if (r) r(); });
  }

  // ---------- generate 4 previews, show them, make the picked one print-ready and put it on the sign ----------
  function generate() {
    if (S.busy || S.off) return;
    var lines = readLines();
    if (!lines.headline) { showErr('Type the main words for your sign.'); var h = $('[data-aya-line="headline"]'); if (h) h.focus(); return; }
    if (S.left === 0 && !S.hasEmail) { openGate(generate); return; }
    showErr('');
    var p = plan(), notes = clean($('[data-aya-notes]').value).slice(0, LIMITS.notes);
    busy(true, 'Designing your sign… this takes about a minute.');
    uploadLogo().then(function (logoId) {
      return botToken().then(function (token) {
        var body = withEmail({ visitor: visitor, token: token, product: 'banner', widthFt: p.widthFt, heightFt: p.heightFt, style: S.style, styleNotes: notes, lines: lines });
        if (logoId) body.logoId = logoId;
        return api('/api/banner/generate', body, 240000);
      });
    }).then(function (j) {
      busy(false);
      if (j.bannersLeft != null) S.left = j.bannersLeft;
      if ('hasEmail' in j) S.hasEmail = !!j.hasEmail;
      syncQuota();
      if (!j.ok || !j.images || !j.images.length) {
        if (j.error === 'need_email') { S.left = 0; syncQuota(); openGate(generate); return; }
        showErr(j.message || 'We couldn\'t make your designs this time. Please try again.');
        return;
      }
      S.batch = { images: j.images.slice(0, 4), size: p.size, logoId: S.logoId || '', lines: lines, portrait: p.heightFt > p.widthFt };
      track('ardor_yardsign_ai_generated', { size: p.size, sides: p.c.sides });
      showResults();
    }, function (err) {
      busy(false);
      showErr((err && err.message) || 'We couldn\'t upload your logo. Try another file, or remove it and try again.');
    });
  }
  function showResults() {
    var box = $('[data-aya-results]'), b = S.batch; box.textContent = '';
    if (!b) return;
    box.appendChild(el('p', 'abl-help', 'Tap a design to put it on your sign.'));
    var grid = el('div', 'aya-grid');
    b.images.forEach(function (im, i) {
      var card = el('button', 'aya-card');
      card.type = 'button'; card.setAttribute('data-aya-use', im.id); card.setAttribute('aria-label', 'Use design ' + (i + 1));
      card.innerHTML = '<span class="aya-card__img"><img alt="" loading="lazy" src="' + esc(im.url) + '"></span><span class="aya-card__go">Use this design</span>';
      grid.appendChild(card);
    });
    box.appendChild(grid);
  }
  function useDesign(id) {
    if (S.busy || !S.batch) return;
    var b = S.batch, img = b.images.filter(function (x) { return x.id === id; })[0];
    if (!img) return;
    showErr('');
    busy(true, 'Making a sharp, print-ready version… about 30 to 60 seconds.');
    botToken().then(function (token) {
      return api('/api/banner/final', withEmail({ visitor: visitor, token: token, imageId: id }), 420000);
    }).then(function (j) {
      if (!j.ok || !j.image || !j.image.id) {
        busy(false);
        if (j.error === 'need_email') { openGate(function () { useDesign(id); }); return; }
        showErr(j.message || 'We couldn\'t make the print version. Please try again.');
        return;
      }
      var fin = j.image, lb = (fin.check && fin.check.logoBox) || (img.check && img.check.logoBox) || null;
      var L = LY();
      if (!L || !L.placeAi) { busy(false); showErr('Please reload the page and try again.'); return; }
      var face = plan().face;
      return L.placeAi({ id: fin.id, face: face, logo: b.logoId, lb: lb }).then(function () {
        busy(false);
        track('ardor_yardsign_ai_design_used', { size: b.size, face: face });
        if (L.closeDrawer) L.closeDrawer();
        var msg = b.logoId ? 'Your AI design is on your sign. Tap "Use my exact logo" to put your original logo over the AI\'s version.' : 'Your AI design is on your sign. Move it, resize it, or add text and clipart.';
        if (L.toast) L.toast(msg, 8000);
      });
    }).catch(function () { busy(false); showErr('We couldn\'t put the design on your sign. Please try again.'); });
  }

  // ---------- start: wait for the builder and the drawer ----------
  var tries = 0;
  (function wait() {
    var host = root.querySelector('[data-aya-host]');
    if (host && YS() && LY() && LY().placeAi) { build(host); window.ArdorYardSignAI = { plan: plan, quota: quota, state: S }; return; }
    if (++tries < 300) setTimeout(wait, 100);
  })();
})();
